export default "__VITE_ASSET__90811d3c__"